<template>
  <div>
    <template v-if='statusGeral !== ""'>
      <RF-Status :cpntStatus='statusGeral' :cpntTamanho='5'></RF-Status>
    </template>

    <template v-else-if='statusGeral === ""'>
      <div v-if="Object.keys(tabelasFilho).length >= 1">
        <div v-if="grafico !== false" v-show="mostrarGrafico === true">
          <div style="margin-top: -30px; display: inline-block;">
            Apresentar gráfico por:
              <RF-Componente style="display: inline-block; vertical-align: middle;"
                :data-time='time'
                :cpntTamanho='grafico.tamanho'
                :cpntModelo='grafico.tipo'
                :cpntStatus='grafico.status'
                :cpntId='grafico.id'
                :cpntClassDivField='grafico.classDivField'
                :cpntNome='""'
                :cpntValue='grafico.value'
                :cpntValueRef='grafico.valueRef'
                :cpntOptions='grafico.options'
                :cpntKeyValue='grafico.keyValue'
                :cpntKeyMostra='grafico.keyMostra'
                :cpntAutoComplete='grafico.autocomplete'
                :cpntDisabled='grafico.disabled'
                :cpntMostrar='grafico.mostrar'
                :cpntMensagem='grafico.mensagem'
                :cpntSelecioneNome='grafico.selecioneNome'
                :cpntSelecioneValue='grafico.selecioneValue'
                :cpntMensagemTipo='grafico.mensagemTipo'
                :cpntAdicinarOption='grafico.adicinarOption'
                :cpntMultiple='grafico.multiple'
                :cpntAllRegistro='grafico.allRegistro'
                :cpntExplica='grafico.explica'
                :cpntTabIndex='grafico.tabIndex'
                :cpntOptionInicialNome='grafico.optionInicialNome'
                :cpntOptionInicialValue='grafico.optionInicialValue'

                :cpntOnChange='grafico.onChange'
                :cpntOnBlur='grafico.onBlur'
                :ref='grafico.tipo'
              ></RF-Componente>
          </div>

          <div class="chart-container">
            <canvas id="myChart" ref="grafico" width="1000" height="300" style="position: relative; z-index: 1;"></canvas>
          </div>
        </div>

        <div v-for="(filho, index, posicao) in tabelasFilho" :key="index" :id='filho.id + "-relatorio"' class="rel-tab-cli">
          <RF-Tabela :key="index + '-tabela'" :data-time='time' style="margin: 25px 0px;"
            :cpntTime='time'
            :cpntId='filho.id'
            :cpntStatus='filho.status'
            :cpntButtonImprimir='filho.acoes.btImprimir'
            :cpntButtonAtualizar='filho.acoes.btAtualizar'
            :cpntFraseTop='filho.fraseTop'
            :cpntInfoTabela='filho.infoTabela'
            :cpntColuna='filho.coluna'
            :cpntLinha='filho.linha'
            :cpntCountAll='filho.countAll'
            :cpntColspan='filho.colspan'
            :cpntButtonsAcoes='filho.acoes.buttons'
            :cpntMper='{}'
            :cpntPagina='filho.pagina'
            :cpntCheckboxEditar='filho.checkboxEditar'
            :cpntFieldsEditar='filho.acoes.fields'
            :cpntButtonImprimirOculta='filho.buttonImprimirOculta'
            :cpntPrintId='filho.printId'
            :cpntMostrarCabecalhoRelatorio='[ 0, "0" ].indexOf(posicao) !== -1'

            :cpntOnRefreshTabela='vendasRelatoriosInfosIniciar'
            :ref='filho.id'>
            <template slot="rel-cabecalho">
              <!-- SETA O CABECALHO DO RELATORIO -->
              <RF-Relatorio-Cabecalhos :cpntTime="time">
                <template slot="rel-nome">
                  <h4>RELATORIO POR CLIENTE</h4>
                </template>
              </RF-Relatorio-Cabecalhos>
            </template>
            </RF-Tabela>
          <table :key="index + '-info'" class="tabela-rel-info">
            <tr v-for="(linha, indexL) in filho.adicional" :key="index + '-info-' + indexL">
              <td v-for="(coluna, indexC) in linha" :key="index + '-info-' + indexL + '-' + indexC" v-html="coluna"></td>
            </tr>
          </table>

          <!-- <hr class="separador"/> -->
        </div>

      </div>
      <template v-else>
        <div style="text-align: center; margin: 10px 0px;">Nenhum registro encontrado.</div>
      </template>
    </template>
  </div>
</template>

<style scoped>
  .tabela-rel-info {
    margin-top: -25px;
    margin-right: 1px;
    margin-bottom: 20px;
    width: 300px;
    float: right;
  }
  .tabela-rel-info > tr:not(:first-child) {
    border-top: 1px solid #d5dee5;
  }
  .tabela-rel-info > tr {
    border-bottom: 1px solid #d5dee5;
  }
    .tabela-rel-info > tr > td {
      text-align: right;
      padding: 4px;
    }
      .tabela-rel-info > tr > td:first-child {
        border-left: 1px solid #d5dee5;
      }
      .tabela-rel-info > tr > td:last-child {
        border-right: 1px solid #d5dee5;
      }
</style>

<style>
.rel-tab-cli > div > table > tbody > tr > td > div.link-rf-forms {
  text-decoration: none !important;
}
@media print {
  .rel-tab-cli {
    margin-top: -45px;
    margin-left: -10px;
  }
}
.venda-relatorios > div > span > .rf-conteudo-mPer {
  right: 1% !important;
}
  .venda-relatorios > div > span > .rf-conteudo-mPer > .rf-tooltip-triangle {
    display: none !important;
  }

  .rel-tab-cli > div > table > thead > tr > th > span.link-contato,
  .rel-tab-cli > div > table > thead > tr > th > .link-contato > div:not(.rf-dialog) {
    max-width: max-content !important;
    margin: 3px 0px !important;
    padding: 0px !important;
    text-decoration: none !important;
    font-size: var(--font-base-soma-17);
  }
  .rel-tab-cli > div > table > thead > tr > th > button {
    margin: 0px 5px;
    background: none !important;
    border: none !important;
    display: none;
  }
  .rel-tab-cli > div > table > thead > tr > th:hover > button {
    display: inline-block;
  }

  .rel-tab-cli > div > table {
    border: none !important;
    width: 100% !important;
  }
    .rel-tab-cli > div > table > thead > tr:first-child > th {
      text-align: left !important;
      padding: 0px !important;
    }
    .rel-tab-cli > div > table > thead > tr:first-child,
    .rel-tab-cli > div > table > thead > tr:first-child > th {
      background: none !important;
      border: none !important;
    }
    .rel-tab-cli > div > table > tbody > tr:last-child > td {
      font-weight: bold;
    }
</style>

<script>
  export default {
    props: {
      cpntSetarStatusButton: {
        required: true
      },
      cpntSetarMper: {
        required: true
      }
    },
    components: {
      'RF-Relatorio-Cabecalhos': () => import('@/components/rf-geral/relatorios/RF-Cabecalhos.vue')
    },
    data: function () {
      return {
        time: '',
        statusGeral: 'carregando',
        tabela: {},
        tabelasFilho: {},
        grafico: false,
        mostrarGrafico: true,
        cpntFiltros: {}
      }
    },
    methods: {
      vendasRelatoriosInfosStart: function () {
        // SETA QUE NÃO DEVE MOSTRAR O GRAFICO
        this.grafico = false
        
        // SETA O STATUS DA TELA
        this.vendasRelatoriosInfosSetarStatusGeral('carregando')
      },
      vendasRelatoriosInfosSetarStatusGeral: function (status) {
        // SETA O STATUS DO BUTTON
        if ([ 'carregando', '' ].indexOf(status) !== -1 && typeof this.cpntSetarStatusButton === 'function') {
          this.cpntSetarStatusButton(status)
        }

        // SETA O STATUS DA TELA
        this.statusGeral = status

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },

      vendasRelatoriosInfosIniciar: function (filtros) {
        var self = this

        // SETA OS VALORES RECEBIDOS
        if (filtros !== null) {
          self.cpntFiltros = filtros
        }

        // SETA O STATUS DO BUTTON
        self.vendasRelatoriosInfosSetarStatusGeral('carregando')

        // SETA QUE NÃO DEVE MOSTRAR O GRAFICO
        self.grafico = false

        // LIMPA OS CAMPOS PARA SEREM INICIANDO NOVAMENTE
        self.tabela = {
          status: 'carregando',
          id: 'venda-relatorio-infos',
          api: {
            model: 'VenRelCliente'
          },
          mper: {
            field: true,
            rpp: false,
            fazerOrder: false,
            // order: '3',
            // orderField: [
            //   { id: 'asc' },
            //   { id: 'desc' },
            //   { nome_prod: 'asc' },
            //   { qtde_total: 'asc' },
            //   { qtde_total: 'desc' }
            // ],
            // orderOptions: [
            //   { value: '0', nome: 'Código Ordem Crescente' },
            //   { value: '1', nome: 'Código Ordem Decrescente' },
            //   { value: '2', nome: 'Ordem Alfabética' },
            //   { value: '3', nome: 'Quantidade Crescente' },
            //   { value: '4', nome: 'Quantidade Decrescente' },
            // ]
          },
          acoes: {
            buttons: [],
            btImprimir: false
          },
          ids: [],
          buscarLinhasApi: false,
          buttonImprimirOculta: [ 'historico' ]
        }

        // INFORMA TODAS AS COLUNAS DA TABELA
        self.tabela.colunaAll = [
          { mPer: 1, chave: 'tipo_nome', nome: 'Tipo' },
          { mPer: 1, chave: 'id_item_codigo', nome: 'Cod.' },
          { mPer: 2, chave: 'nome_prod', nome: 'Nome', tipo: 'link-cadastro', converte: { tipo: 'tipo', id: 'id_item', nome: 'id_item_nome', status: 'id_item_status' }, mostrarButton: true },
          { mPer: 1, chave: 'id_item_id_cat_nome', nome: 'Categoria' },
          { mPer: 1, chave: 'id_item_id_mar_nome', nome: 'Marca' },
          { mPer: 1, chave: 'qtde_vendas', nome: 'Quantidade Venda', explica: { mensagem: 'Número de vendas que foram incluído este(s) item(ns).', posicaoMy: 'top right', posicaoAt: 'bottom left' } },
          { mPer: 2, chave: 'qtde_total_ptbr', nome: 'Quantidade Total' },
          { mPer: 2, chave: 'venda_total_ptbr', nome: 'Venda Total' },
          { mPer: 2, chave: 'valor_medio_ptbr', nome: 'Ticket médio', explica: { mensagem: 'Venda Total / Quantidade Total = Ticket médio', posicaoMy: 'top right', posicaoAt: 'bottom left' } },
          { mPer: 1, chave: 'historico', nome: 'Histórico' }
        ]

        var colunaRemover = []

        // COPIA OS DADOS PARA COLUNA 
        self.tabela.coluna = self.tabela.colunaAll.filter(item => colunaRemover.indexOf(item.chave) === -1)

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        self.time = new Date().getTime()

        // FAZ A MONTAGEM DAS INFORMAÇÕES PARA TABELA
        self.$store.state.FUN_TABELA_CRIAR_DADOS(self.tabela, function (tabelaSuccess) {
          // SETA OS DADOS RECEBIDOS PARA TABELA
          self.tabela = tabelaSuccess

          // // SETA A MINHA PERSONALIZAÇÃO DA TABELA
          // self.cpntSetarMper(self.tabela.mper)

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          self.time = new Date().getTime()

          // CHAMA A FUNÇÃO PARA BUSCAR OS PRODUTOS
          self.vendasRelatoriosInfosTabelaBuscarProdutos(function (retornos) {
            var index = 0
            var tabelaInicial = JSON.parse(JSON.stringify(self.tabela))
            self.tabelasFilho = {}

            for (var key in retornos) {
              // CONVERTE O VALOR PARA TIPO INT
              var tab = Number(retornos[key].cod_venda_id_con)

              // CRIA O CAMPO MARCA SE ELE NÃO EXISTIR
              if (!retornos[key].hasOwnProperty('id_item_id_mar_nome')) {
                retornos[key].id_item_id_mar_nome = '---'
              }

              if (retornos[key].hasOwnProperty('id_pro_id_cat') && retornos[key].hasOwnProperty('id_pro_id_mar')) {
                retornos[key].tipo = 1
                retornos[key].tipo_nome = 'Produto'
                retornos[key].id_item_codigo = retornos[key].id_item_codigo
              } else {
                retornos[key].tipo = 2
                retornos[key].tipo_nome = 'Serviço'
                retornos[key].id_item_codigo = retornos[key].id_item
              }

              // VERIFICA SE O PRODUTO JÁ FOI TRATADO
              if (!self.tabelasFilho.hasOwnProperty(tab)) {
                // SETA O PRODUTO NO VETOR PARA MOSTRAR QUE ELE JÁ EXISTE
                self.tabelasFilho[tab] = JSON.parse(JSON.stringify(tabelaInicial))

                // LIMPA AS LINHA DA TABELA
                self.tabelasFilho[tab].linha = []

                // INICIA A VARIAVEL PARA CONTAR OS PRODUTOS
                if (retornos[key].hasOwnProperty('id_item')) {
                  self.tabelasFilho[tab].produtos = []
                }

                // INICIA OS VALORES DAS VARIAVEIS
                self.tabelasFilho[tab].qtde_total = 0
                self.tabelasFilho[tab].valor_total = 0
                self.tabelasFilho[tab].vendas = []
                self.tabelasFilho[tab].valor_medio = 0

                // ADICIONA O PARAMETRO PARA O ID DA TABELA
                self.tabelasFilho[tab].id += '-' + tab
                self.tabelasFilho[tab].printId = self.tabelasFilho[tab].id + '-relatorio'
              }

              // CALCULA A QUANTIDADE DE VENDAS REALIZADAS PARA ESTE CLIENTE
              self.tabelasFilho[tab].vendas.push(retornos[key].cod_venda)

              // CONVERTE O VALOR PARA TIPO INT
              retornos[key].id_item = Number(retornos[key].id_item)
              retornos[key].qtde = Number(retornos[key].qtde)
              retornos[key].valor_tot = Number(retornos[key].valor_tot)

              // VERIFICA SE O PRODUTO JÁ FOI TRATADO
              if (!self.tabelasFilho[tab].produtos.hasOwnProperty(retornos[key].id_item)) {
                // SETA O PRODUTO NO VETOR PARA MOSTRAR QUE ELE JÁ EXISTE
                self.tabelasFilho[tab].produtos[retornos[key].id_item] = self.tabelasFilho[tab].linha.length //  >= 0 ? self.tabelasFilho[tab].linha.length - 1 : 0

                // INICIA OS VALORES DA LINHA
                retornos[key].qtde_total = 0
                retornos[key].venda_total = 0
                retornos[key].vendas = []

                // SETA OS DADOS DO PRODUTO NA LINHA
                self.tabelasFilho[tab].linha.push(retornos[key])
              }
              
              // PEGA QUAL É A LINHA QUE ESTA SENDO TRATADA
              index = self.tabelasFilho[tab].produtos[retornos[key].id_item]

              // SOMA A QUANTIDADE JÁ EXISTENTE COM A QUANTIDADE RECEBIDA DO PRODUTO
              self.tabelasFilho[tab].linha[index].qtde_total += retornos[key].qtde

              // SOMA O VALOR TOTAL VENDIDO
              self.tabelasFilho[tab].linha[index].venda_total += retornos[key].valor_tot

              // SALVA O NUMERO DA VENDA
              self.tabelasFilho[tab].linha[index].vendas.push(retornos[key].cod_venda)

              self.tabelasFilho[tab].linha[index].historico = [
                {
                  id: self.tabelasFilho[tab].id + '--' + self.tabelasFilho[tab].linha[index].cod_venda_id_con + '--' + index + '--0',
                  status: '',
                  tipo: 'button',
                  texto: 'Histórico',
                  class: 'btn btn-sm btn-info',
                  onClick: function (indexL, indexC, indexO, objecto) {
                    // PEGA OS DADOS DO CLIQUE RECEBIDO
                    var indexBT = objecto.id.split('--')
                    var tab = 'tab--' + indexBT[0].split('-')[3]

                    // INICIA A VARIAVEL
                    var link = ''
                    var params = {}

                    // MONTA O LINK PARA ABERTURA
                    switch (self.tabelasFilho[tab].linha[indexBT[1]].tipo) {
                      case 1:
                        // link += process.env.VUE_APP_URL_CS + '/app/produtos/produtos_his.php?cts=' + self.$store.state.token.cts
                        // link += '&p=' + self.tabelasFilho[tab].linha[indexBT[1]].id_item
                        // link += '&c=' + self.tabelasFilho[tab].linha[indexBT[1]].id_pro_id_cat
                        // link = self.$router.resolve({ name: 'produto_historico_busca', params: { cts: self.$store.state.token.cts, cpntFiltros: window.btoa(JSON.stringify({ pro: [ self.tabelasFilho[tab].linha[indexBT[1]].id_item.toString() ] })) } }).href
                        link = 'produto_historico_busca'
                        params = { pro: [ self.tabelasFilho[tab].linha[indexBT[1]].id_item.toString() ] }
                        break

                      case 2:
                        // link += process.env.VUE_APP_URL_CS + '/app/servicos/servicos_his.php?cts=' + self.$store.state.token.cts
                        // link += '&s=' + self.tabelasFilho[tab].linha[indexBT[1]].id_item
                        // link += '&c=' + self.tabelasFilho[tab].linha[indexBT[1]].id_ser_id_cat
                        // link = self.$router.resolve({ name: 'servico_historico_busca', params: { cts: self.$store.state.token.cts, cpntFiltros: window.btoa(JSON.stringify({ ser: [ self.tabelasFilho[tab].linha[indexBT[1]].id_item.toString() ] })) } }).href
                        link = 'servico_historico_busca'
                        params = { ser: [ self.tabelasFilho[tab].linha[indexBT[1]].id_item.toString() ] }
                        break
                    }

                    // VERIFICA SE FOI FILTRADO POR CONTATO
                    // link += '&con=' + self.tabelasFilho[tab].linha[indexBT[1]].cod_venda_id_con

                    // VERIFICA SE FOI FILTRADO POR CONTATO
                    if (self.cpntFiltros.hasOwnProperty('contato') && [ 't', '' ].indexOf(self.cpntFiltros.contato.join()) === -1) {
                      params.con = self.cpntFiltros.contato
                      // link += '&con=' + self.cpntFiltros.contato.join()
                    }

                    // VERIFICA O CAMPO PERIODO
                    if (self.cpntFiltros.hasOwnProperty('periodo') && self.cpntFiltros.periodo.dataIni !== '' && self.cpntFiltros.periodo.dataFim !== '') {
                      params.dat = { id: '99', dataIni: self.cpntFiltros.periodo.dataIni, dataFim: self.cpntFiltros.periodo.dataFim }
                      // link += '&per1=' + encodeURI(window.btoa(unescape(encodeURIComponent(self.cpntFiltros.periodo.dataIni))))
                      // link += '&per2=' + encodeURI(window.btoa(unescape(encodeURIComponent(self.cpntFiltros.periodo.dataFim))))
                    }

                    // SETA O FILTRO DE STATUS DA VENDA NA BUSCA DA TABELA
                    if (self.cpntFiltros.hasOwnProperty('status_ven')) {
                      params.dem_sta = []
                      if (self.cpntFiltros.status_ven.join() !== 't') {
                        for (var sta in self.cpntFiltros.status_ven) {
                          switch (self.cpntFiltros.status_ven[sta]) {
                            case '1': // ORÇAMENTO
                              // status.push('1v')
                              params.dem_sta.push('dem_venda__1')
                              break

                            case '2': // VENDA
                              // status.push('2v')
                              params.dem_sta.push('dem_venda__2')
                              break
                          
                            default:
                              self.$store.state.msgWarn('WEB [500]: Erro ao identificar o status para o historico de produto/serviço.', 'danger')
                              break;
                          }
                        }
                        // link += '&sta=' + status.join(',')
                      } else if (self.cpntFiltros.status_ven.join() === 't') {
                        // link += '&sta=1v,2v'
                        params.dem_sta = params.dem_sta.concat([ 'dem_venda__1', 'dem_venda__2' ])
                      }
                    }
                    
                    // ABRE O LINK MONTADO
                    // self.$store.state.OPEN_PAGE_CS(link, '_blank')
                    self.$store.state.OPEN_PAGE_CS(self.$router.resolve({ name: link, params: { cts: self.$store.state.token.cts, cpntFiltros: window.btoa(JSON.stringify(params)) } }).href, '_blank')
                  }
                }
              ]
            }
            
            for (var tab2 in self.tabelasFilho) {
              // SETA O STATUS DA TABELA
              self.tabelasFilho[tab2].status = ''

              // FORMATA OS CAMPOS DE CADA TABELA
              for (var lin in self.tabelasFilho[tab2].linha) {
                // FORMATA A QUANTIDADE SOMADA
                self.tabelasFilho[tab2].linha[lin].qtde_total_ptbr = self.$store.state.FUN_MASK_VALOR('valorDecimal', self.tabelasFilho[tab2].linha[lin].qtde_total.toFixed(4))

                // SOMA O VALOR ENCONTRADO PARA O TOTAL DA TABELA
                self.tabelasFilho[tab2].qtde_total += self.tabelasFilho[tab2].linha[lin].qtde_total

                // FORMATA O VALOR SOMADO
                self.tabelasFilho[tab2].linha[lin].venda_total_ptbr = self.$store.state.FUN_MASK_VALOR('valorMoeda', self.tabelasFilho[tab2].linha[lin].venda_total)

                // SOMA O VALOR ENCONTRADO PARA O TOTAL DA TABELA
                self.tabelasFilho[tab2].valor_total += self.tabelasFilho[tab2].linha[lin].venda_total

                // SOMA O VALOR ENCONTRADO PARA O TOTAL DA TABELA
                self.tabelasFilho[tab2].linha[lin].valor_medio += (self.tabelasFilho[tab2].linha[lin].venda_total / self.tabelasFilho[tab2].linha[lin].qtde_total).toFixed(0)

                // FORMATA O VALOR SOMADO
                self.tabelasFilho[tab2].linha[lin].valor_medio_ptbr = self.$store.state.FUN_MASK_VALOR('valorMoeda', self.tabelasFilho[tab2].linha[lin].valor_medio)

                // REMOVER VALORES DUPLICADOS
                self.tabelasFilho[tab2].linha[lin].vendas = self.tabelasFilho[tab2].linha[lin].vendas.filter((v, i, a) => a.indexOf(v) === i)

                // SETA A QUANTIDADE DE VENDAS
                self.tabelasFilho[tab2].linha[lin].qtde_vendas = self.tabelasFilho[tab2].linha[lin].vendas.length.toString()
              }
              
              // REMOVER VALORES DUPLICADOS
              self.tabelasFilho[tab2].vendas = self.tabelasFilho[tab2].vendas.filter((v, i, a) => a.indexOf(v) === i)

              // CONTA QUANTAS VENDAS FOI ENCONTRADO
              self.tabelasFilho[tab2].qtde_venda = self.tabelasFilho[tab2].vendas.length

              // CALCULA O VALOR MEDIO POR VENDA
              self.tabelasFilho[tab2].valor_medio = (self.tabelasFilho[tab2].valor_total / self.tabelasFilho[tab2].qtde_total).toFixed(0)

              // FORMATA O VALOR SOMADO
              self.tabelasFilho[tab2].qtde_total_ptbr = self.$store.state.FUN_MASK_VALOR('valorDecimal', self.tabelasFilho[tab2].qtde_total.toFixed(4))

              // FORMATA O VALOR SOMADO
              self.tabelasFilho[tab2].valor_total_ptbr = self.$store.state.FUN_MASK_VALOR('valorMoeda', self.tabelasFilho[tab2].valor_total)

              // FORMATA O VALOR SOMADO
              self.tabelasFilho[tab2].valor_medio_ptbr = self.$store.state.FUN_MASK_VALOR('valorMoeda', self.tabelasFilho[tab2].valor_medio)

              var inicio = [
                // '<span class="rf-tipo-normal" style="font-weight: normal; padding-top: 2px;">&nbsp;Contato: </span>',
                {
                  tipo: 'link-contato',
                  id_con: self.tabelasFilho[tab2].linha[0].cod_venda_id_con,
                  id_con_nome: self.tabelasFilho[tab2].linha[0].cod_venda_id_con_nome,
                  id_con_empresa: self.tabelasFilho[tab2].linha[0].cod_venda_id_con_empresa,
                  id_con_pessoa: self.tabelasFilho[tab2].linha[0].cod_venda_id_con_pessoa,
                  id_con_status: self.tabelasFilho[tab2].linha[0].cod_venda_id_con_status
                },
                {
                  id: self.tabelasFilho[tab].id + '--' + self.tabelasFilho[tab].linha[index].cod_venda_id_con + '--' + index + '--imprimir',
                  status: '',
                  tipo: 'button',
                  tipoButton: 'icone',
                  icone: { tipo: 'impressora' },
                  class: 'btn btn-sm btn-default',
                  onClick: self.vendasRelatoriosInfosTabelaImprimir
                }
              ]

              var extra = {
                tipo_nome: '',
                id_item_codigo: '',
                nome_prod: '',
                id_item_id_cat_nome: '',
                id_item_id_mar_nome: 'Total',
                qtde_vendas: self.tabelasFilho[tab2].qtde_venda,
                qtde_total_ptbr: self.tabelasFilho[tab2].qtde_total_ptbr,
                venda_total_ptbr: self.tabelasFilho[tab2].valor_total_ptbr,
                valor_medio_ptbr: self.tabelasFilho[tab2].valor_medio_ptbr,
                historico: '---'
              }

              // ADICIONA A LINHA DE TOTAIS
              self.tabelasFilho[tab2].linha.push(extra)

              // JUNTAS OS DOIS VALORES PARA O TITULO DA TABELA
              self.tabelasFilho[tab2].infoTabela = inicio
            }

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            self.time = new Date().getTime()

            // SETA O STATUS DO BUTTON
            self.vendasRelatoriosInfosSetarStatusGeral('')

            // SETA A MINHA PERSONALIZAÇÃO DA TABELA
            self.cpntSetarMper(Object.keys(self.tabelasFilho).length >= 1 ? self.tabela.mper : {})

            if (Object.keys(self.tabelasFilho).length >= 2) {
              // CHAMA A FUNÇÃO PARA MONTAR O GRAFICO
              self.vendasRelatoriosInfosGraficoIniciar()
            }
          })
        }, self.vendasRelatoriosInfosSetarStatusGeral)
      },
      vendasRelatoriosInfosTabelaImprimir: function (id) {
        var self = this

        // PEGA O ID DA TABELA QUE ESTA SENDO IMPRESSA
        id = id.split('--')[0]
        var index = id.split('-')
        index = index[index.length - 1]

        // CHAMA A FUNÇÃO PARA SETAR STATUS DE IMPRESSÃO
        self.vendasRelatoriosInfosTabelaImprimirPartes(id)

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        self.time = new Date().getTime()

        setTimeout(function () {
          // CHAMADA DO PLUGIN PARA IMPRIMIR CONTEUDO DA DIV
          $('#' + self.tabelasFilho['tab--' + index].printId).printElement()

          setTimeout(function () {
            // CHAMA A FUNÇÃO PARA SETAR STATUS DE IMPRESSÃO
            self.vendasRelatoriosInfosTabelaImprimirPartes(id)

            // SETA O STATUS DO BUTTON
            self.buttonImprimir.status = ''

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            self.time = new Date().getTime()
          }, 500)
        }, 500)
      },
      vendasRelatoriosInfosTabelaImprimirPartes: function (id, tentativa = 0) {
        var self = this

        if ([ '', null, undefined ].indexOf(self.$refs[id]) === -1) {
          // PEGA QUAL É A TABELA QUE ESTA SENDO ALTERADA
          var tabela = self.$refs[id].hasOwnProperty('$el') ? self.$refs[id] : self.$refs[id][0]

          // SETA O FLAG DE IMPRESSÃO DA TABELA
          tabela.buttonImprimir = !tabela.buttonImprimir

          // SETA O FLAG DE IMPRESSÃO DA TABELA
          tabela.buttonImprimirLocal = !tabela.buttonImprimirLocal

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          tabela.time = new Date().getTime()
        } else if (tentativa <= 10) {
          setTimeout(function () {
            self.vendasRelatoriosInfosTabelaImprimirPartes(id, (tentativa + 1))
          }, 1000)
        }
      },
      vendasRelatoriosInfosTabelaBuscarProdutos: function (callback, total = null, retornos = [], queryGet = {}) {
        var self = this

        if ((self.cpntFiltros.hasOwnProperty('produtos') || (self.cpntFiltros.hasOwnProperty('produtos') && self.cpntFiltros.produtos.indexOf('NENHUM') === -1)) && (total === null || retornos.length < total)) {
          if (Object.keys(queryGet).length === 0) {
            // INICIA O QUERY GET
            queryGet = { type: 'list', where: { aAnd: [ { f: 'status', o: '=', v: '1' }, { m: 'venda', f: 'status', o: '<>', v: '3' } ] } }

            // SETA OS FIELD QUE DEVE SER RETORNADO
            queryGet.field = { id: null, cod_venda: { j: { id_con: { j: { nome: null, empresa: null, pessoa: null, status: null } }, vencimento: null, id_vei: { j: { placa: null } } } }, id_pro: { a: 'id_item', j: { codigo: { a: 'id_item_codigo' }, nome: { a: 'id_item_nome' }, status: { a: 'id_item_status' }, id_cat: { j: { nome: { a: 'id_item_id_cat_nome' } } }, id_mar: { j: { nome: { a: 'id_item_id_mar_nome' } } } } }, qtde: null, valor_tot_novo: { a: 'valor_tot' } }

            // SETA O FILTRO DE STATUS DA VENDA NA BUSCA DA TABELA
            if (self.cpntFiltros.hasOwnProperty('status_ven')) {
              if (self.cpntFiltros.status_ven.join() !== 't') {
                queryGet.where.aAnd.push({ m: 'venda', f: 'status', o: 'in', v: self.cpntFiltros.status_ven.join() })
              } else if (self.cpntFiltros.status_ven.join() === 't') {
                queryGet.where.aAnd.push({ m: 'venda', f: 'status', o: 'in', v: '1,2' })
              }
            }

            // SETA O FILTRO DE CONTATO DA VENDA NA BUSCA DA TABELA
            if (self.cpntFiltros.hasOwnProperty('contato') && [ 't', '' ].indexOf(self.cpntFiltros.contato.join()) === -1) {
              queryGet.where.aAnd.push({ m: 'venda', f: 'id_con', o: 'in', v: self.cpntFiltros.contato.join() })
            }
            
            // SETA O FILTRO DE CONTATO DA VENDA NA BUSCA DA TABELA
            if (self.cpntFiltros.hasOwnProperty('veiculo') && [ 't', '', 'NENHUM' ].indexOf(self.cpntFiltros.veiculo.join()) === -1) {
              queryGet.where.aAnd.push({ m: 'venda', f: 'id_vei', o: 'in', v: self.cpntFiltros.veiculo.join() })
            } else if (self.cpntFiltros.hasOwnProperty('veiculo') && [ 'NENHUM' ].indexOf(self.cpntFiltros.veiculo.join()) !== -1) {
              queryGet.where.aAnd.push({ m: 'venda', f: 'id_vei', o: '=', v: '' })
            }

            // VERIFICA O CAMPO PERIODO
            if (self.cpntFiltros.hasOwnProperty('periodo') && self.cpntFiltros.periodo.dataIni !== '' && self.cpntFiltros.periodo.dataFim !== '') {
              var dataIni = self.cpntFiltros.periodo.dataIni.split('/')
              queryGet.where.aAnd.push({ m: 'venda', f: 'vencimento', o: '>=', v: dataIni[2] + '-' + dataIni[1] + '-' + dataIni[0] })

              var dataFim = self.cpntFiltros.periodo.dataFim.split('/')
              queryGet.where.aAnd.push({ m: 'venda', f: 'vencimento', o: '<=', v: dataFim[2] + '-' + dataFim[1] + '-' + dataFim[0] })
            }

            // SETA O FILTRO DE CATEGORIA NA BUSCA DA TABELA
            if (self.cpntFiltros.hasOwnProperty('produtos') && [ 't', '' ].indexOf(self.cpntFiltros.produtos.join()) === -1) {
              queryGet.where.aAnd.push({ f: 'id_pro', o: 'in', v: self.cpntFiltros.produtos.join() })
            }

            // SETA O FILTRO DE CATEGORIA NA BUSCA DA TABELA
            if (self.cpntFiltros.hasOwnProperty('comissionado') && [ 't', '' ].indexOf(self.cpntFiltros.comissionado.join()) === -1) {
              queryGet.where.aAnd.push({ f: 'cms_com_id', o: 'in', v: self.cpntFiltros.comissionado.join() })
            }

            // PEGA APENAS VALORES QUE SÃO DIFERENTE DE NOTA DE ENTRADA
            if ([ '', null, undefined ].indexOf(self.cpntFiltros.tpNF) === -1) {
              switch (self.cpntFiltros.tpNF) {
                case '0':
                  queryGet.where.aAnd.push({ m: 'venda', f: 'p_doc_docs', o: '<>', v: '0' })
                  queryGet.where.aAnd.push({ aOr: [ { m: 'venda', f: 'p_doc_ope', o: '=', v: '0' } ] })
                  break

                case '1':
                  queryGet.where.aAnd.push({ m: 'venda', f: 'p_doc_docs', o: '<>', v: '0' })
                  queryGet.where.aAnd.push({ aOr: [ { m: 'venda', f: 'p_doc_ope', o: '=', v: '1' } ] })
                  break

                case '100':
                  break

                case '101':
                  queryGet.where.aAnd.push({ m: 'venda', f: 'p_doc_docs', o: '<>', v: '0' })
                  queryGet.where.aAnd.push({ aOr: [ { m: 'venda', f: 'p_doc_ope', o: '=', v: '0' }, { m: 'venda', f: 'p_doc_ope', o: '=', v: '1' } ] })
                  break

                case '102':
                  queryGet.where.aAnd.push({ m: 'venda', f: 'p_doc_docs', o: '=', v: '0' })
                  break
              }
            }
          }

          // INICIA A VARIAVEL LIMIT
          queryGet.limit = { row: 0, qty: 1000 }
          
          // PEGA OS REGISTROS JÁ BUSCADOS
          if (retornos.length >= 1) {
            queryGet.limit = { row: retornos.length, qty: 1000 }
          }

          self.$store.state.comunicaAPI('/venda/produto/get', 'POST', queryGet, function (apiSuccess) {
            // SETA OS VALORES RECEBIDOS
            retornos = retornos.concat(apiSuccess.data)

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            self.time = new Date().getTime()

            // CHAMA A FUNÇÃO PARA BUSCAR OS PRODUTOS
            self.vendasRelatoriosInfosTabelaBuscarProdutos(callback, (Number(apiSuccess.countAll) - 1), retornos, queryGet) // DIMINUI 1 POR QUE O VETOR INICIA NA POSIÇÃO 0
          }, self.vendasRelatoriosInfosSetarStatusGeral)
        } else {
          // REMOVE O PONTO DO VALOR RECEBIDO
          for (var index in retornos) {
            retornos[index].valor_tot = retornos[index].valor_tot.replace('.', '')
          }

          // CHAMA A FUNÇÃO CALLBACK DO RETORNO
          self.vendasRelatoriosInfosTabelaBuscarServico(callback, null, [], retornos)
        }
      },
      vendasRelatoriosInfosTabelaBuscarServico: function (callback, total = null, retornos = [], dados = [], queryGet = {}) {
        var self = this

        if ((self.cpntFiltros.hasOwnProperty('servicos') || (self.cpntFiltros.hasOwnProperty('servicos') && self.cpntFiltros.servicos.indexOf('NENHUM') === -1)) && (total === null || retornos.length < total)) {
          if (Object.keys(queryGet).length === 0) {
            // INICIA O QUERY GET
            queryGet = { type: 'list', where: { aAnd: [ { f: 'status', o: '=', v: '1' }, { m: 'venda', f: 'status', o: '<>', v: '3' } ] } }

            // SETA OS FIELD QUE DEVE SER RETORNADO
            queryGet.field = { id: null, cod_venda: { j: { id_con: { j: { nome: null, empresa: null, pessoa: null, status: null } }, vencimento: null, id_vei: { j: { placa: null } } } }, id_ser: { a: 'id_item', j: { nome: { a: 'id_item_nome' }, status: { a: 'id_item_status' }, id_cat: { j: { nome: { a: 'id_item_id_cat_nome' } } } } }, qtde: null, valor_tot: null }
  
            // SETA O FILTRO DE STATUS DA VENDA NA BUSCA DA TABELA
            if (self.cpntFiltros.hasOwnProperty('status_ven')) {
              if (self.cpntFiltros.status_ven.join() !== 't') {
                queryGet.where.aAnd.push({ m: 'venda', f: 'status', o: 'in', v: self.cpntFiltros.status_ven.join() })
              } else if (self.cpntFiltros.status_ven.join() === 't') {
                queryGet.where.aAnd.push({ m: 'venda', f: 'status', o: 'in', v: '1,2' })
              }
            }

            // SETA O FILTRO DE CONTATO DA VENDA NA BUSCA DA TABELA
            if (self.cpntFiltros.hasOwnProperty('contato') && [ 't', '' ].indexOf(self.cpntFiltros.contato.join()) === -1) {
              queryGet.where.aAnd.push({ m: 'venda', f: 'id_con', o: 'in', v: self.cpntFiltros.contato.join() })
            }
            
            // SETA O FILTRO DE CONTATO DA VENDA NA BUSCA DA TABELA
            if (self.cpntFiltros.hasOwnProperty('veiculo') && [ 't', '' ].indexOf(self.cpntFiltros.veiculo.join()) === -1) {
              queryGet.where.aAnd.push({ m: 'venda', f: 'id_vei', o: 'in', v: self.cpntFiltros.veiculo.join() })
            }

            // VERIFICA O CAMPO PERIODO
            if (self.cpntFiltros.hasOwnProperty('periodo') && self.cpntFiltros.periodo.dataIni !== '' && self.cpntFiltros.periodo.dataFim !== '') {
              var dataIni = self.cpntFiltros.periodo.dataIni.split('/')
              queryGet.where.aAnd.push({ m: 'venda', f: 'vencimento', o: '>=', v: dataIni[2] + '-' + dataIni[1] + '-' + dataIni[0] })

              var dataFim = self.cpntFiltros.periodo.dataFim.split('/')
              queryGet.where.aAnd.push({ m: 'venda', f: 'vencimento', o: '<=', v: dataFim[2] + '-' + dataFim[1] + '-' + dataFim[0] })
            }

            // SETA O FILTRO DE CATEGORIA NA BUSCA DA TABELA
            if (self.cpntFiltros.hasOwnProperty('servicos') && [ 't', '' ].indexOf(self.cpntFiltros.servicos.join()) === -1) {
              queryGet.where.aAnd.push({ f: 'id_ser', o: 'in', v: self.cpntFiltros.servicos.join() })
            }

            // SETA O FILTRO DE CATEGORIA NA BUSCA DA TABELA
            if (self.cpntFiltros.hasOwnProperty('comissionado') && [ 't', '' ].indexOf(self.cpntFiltros.comissionado.join()) === -1) {
              queryGet.where.aAnd.push({ f: 'cms_com_id', o: 'in', v: self.cpntFiltros.comissionado.join() })
            }

            // PEGA APENAS VALORES QUE SÃO DIFERENTE DE NOTA DE ENTRADA
            queryGet.where.aAnd.push({ aOr: [ { m: 'venda', f: 'p_doc_ope', o: 'isNull' }, { m: 'venda', f: 'p_doc_ope', o: '<>', v: '0' } ] })
          }

          // INICIA A VARIAVEL LIMIT
          queryGet.limit = { row: 0, qty: 1000 }
          
          // PEGA OS REGISTROS JÁ BUSCADOS
          if (retornos.length >= 1) {
            queryGet.limit = { row: retornos.length, qty: 1000 }
          }

          self.$store.state.comunicaAPI('/venda/servico/get', 'POST', queryGet, function (apiSuccess) {
            // SETA OS VALORES RECEBIDOS
            retornos = retornos.concat(apiSuccess.data)

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            self.time = new Date().getTime()

            // CHAMA A FUNÇÃO PARA BUSCAR OS PRODUTOS
            self.vendasRelatoriosInfosTabelaBuscarServico(callback, (Number(apiSuccess.countAll) - 1), retornos, dados, queryGet) // DIMINUI 1 POR QUE O VETOR INICIA NA POSIÇÃO 0
          }, self.vendasRelatoriosInfosSetarStatusGeral)
        } else {
          // SETA OS VALORES RECEBIDOS
          dados = dados.concat(retornos)

          // CHAMA A FUNÇÃO CALLBACK DO RETORNO
          callback(dados)
        }
      },
      vendasRelatoriosInfosGraficoIniciar: function () {
        var self = this

        // SETA QUE NÃO DEVE MOSTRAR O GRAFICO
        if (self.grafico === false) {
          // SETA OS DADOS DO SELETOR DO GRAFICO
          self.grafico = {
            tamanho: 3,
            tipo: 'select2',
            id: 'venda-relatorio-infos-sel-grafico',
            status: '',
            nome: 'Mostrar gráfico por:',
            options: [
              { id: '1', nome: 'Ticket médio' },
              { id: '2', nome: 'Valor total' },
              { id: '3', nome: 'Quantidade' }
            ],
            value: '2',
            keyValue: 'id',
            keyMostra: [ 'nome' ],
            optionInicialNome: '',
            final: null,
            mostrar: true,
            onChange: function (value) {
              // SETA O VALOR ATUALIZADO
              self.grafico.value = value
              
              // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
              self.time = new Date().getTime()

              // CHAMA A FUNÇÃO PARA INICIAR O GRAFICO
              self.vendasRelatoriosInfosGraficoIniciar()
            }
          }

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          self.time = new Date().getTime()
        } else if ([ '', null, undefined ].indexOf(self.grafico.final) === -1) {
          self.grafico.final.destroy()
        }

        var colunas = []
        var valores = []
        var background = []
        var border = []

        // COPIA OS DADOS PARA ORDENAR
        var ordenar = self.tabelasFilho
        self.tabelasFilho = {}

        // ORDENA PELA DATA RECEBIDA
        Object.keys(ordenar).sort(function (a, b) {
          var valor = ''
          switch (self.grafico.value) {
            case '1':
              valor = Number(ordenar[a].valor_medio) > Number(ordenar[b].valor_medio) ? -1 : Number(ordenar[a].valor_medio) < Number(ordenar[b].valor_medio) ? 1 : 0
              break

            case '2':
              valor = Number(ordenar[a].valor_total) > Number(ordenar[b].valor_total) ? -1 : Number(ordenar[a].valor_total) < Number(ordenar[b].valor_total) ? 1 : 0
              break

            case '3':
              valor = Number(ordenar[a].qtde_total) > Number(ordenar[b].qtde_total) ? -1 : Number(ordenar[a].qtde_total) < Number(ordenar[b].qtde_total) ? 1 : 0
              break
          }

          return valor
        }).forEach(function (key) {
          self.tabelasFilho['tab--' + key.toString()] = ordenar[key]
        })

        for (var tab in self.tabelasFilho) {
          if (valores.length <= 25) {
            // PEGAR PARTE DO NOME DO CONTATO
            var nome = self.tabelasFilho[tab].linha[0].cod_venda_id_con_nome.toUpperCase()
            if (nome.length >= 20) {
              nome = nome.substring(0, 20) + '...'
            }

            // ADICIONA O NOME DO CONTATO NA LINHA ABAIXO AO GRAFICO
            colunas.push(nome)

            // ADICIONA O VALOR DE CADA CONTATO
            switch (self.grafico.value) {
              case '1':
                valores.push((self.tabelasFilho[tab].valor_medio / 100))
                break

              case '2':
                valores.push((self.tabelasFilho[tab].valor_total / 100))
                break

              case '3':
                valores.push(self.tabelasFilho[tab].qtde_total)
                break
            }

            // GERA UMA SEQUENCIA DE CORES PARA CADA BARRA
            var cor = self.vendasRelatoriosInfosGraficoRandomColor()

            // PEGA A COR DE FUNDO DA BARRA
            background.push(cor[0])

            // PEGA A COR DA BORTA DA BARRA
            border.push(cor[1])
          } else {
            break
          }
        }
        
        // CHAMA A FUNÇÃO PARA CRIAR O GRAFICO
        self.vendasRelatoriosInfosGraficoCriar(colunas, valores, background, border)
      },
      vendasRelatoriosInfosGraficoCriar: function (colunas, valores, background, border, tentativa = 0) {
        var self = this
        if (tentativa <= 10 && this.$refs.grafico === undefined) {
          setTimeout(function () {
            self.vendasRelatoriosInfosGraficoCriar(colunas, valores, background, border, (tentativa + 1))
          }, 500)
        } else if (this.$refs.grafico !== undefined) {
          // IMPORTA A FUNÇÃO
          const Chart = require('chart.js')
  
          // PEGA A TAG CANVAS
          var canvas = this.$refs.grafico

          // INICIA O TITULO DO GRAFICO
          var titulo = ''

          // ADICIONA O VALOR DE CADA CONTATO
          switch (this.grafico.value) {
            case '1':
              titulo = 'Ticket médio'
              break

            case '2':
              titulo = 'Valor Total'
              break

            case '3':
              titulo = 'Quantidade'
              break
          }

          // INICIA O GRAFICO
          this.grafico.final = new Chart(canvas, {
            type: 'bar',
            data: {
              labels: colunas,
              datasets: [
                {
                  label: titulo,
                  data: valores,
                  backgroundColor: background,
                  borderColor: border
                }
              ]
            },
            options: {
              legend: { display: false },
              // title: {
              //   display: true,
              //   text: titulo
              // },
              tooltips: {
                enabled: true,
                mode: 'single',
                callbacks: {
                  label: function(tooltipItems) {
                    return titulo + ': R$ ' + self.$store.state.FUN_MASK_VALOR('valorMoeda', tooltipItems.yLabel * 100)
                  }
                }
              }
            },
            maintainAspectRatio: false,
          });
        }
      },
      vendasRelatoriosInfosGraficoMostrarOcultar: function () {
        // OCULTA O GRAFICO PRA IMPRIMIR
        this.mostrarGrafico = !this.mostrarGrafico

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      vendasRelatoriosInfosGraficoRandomColor: function () {
        // INICIA AS VARIAVEIS
        var letters = '0123456789ABCDEF'.split('')
        var color = '#'
        var cor = null

        // MONTA A COR DE MANEIRA RADOM
        for (var i = 0; i < 6; i++) {
          color += letters[Math.floor(Math.random() * 16)]
        }

        if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(color)) {
          cor = color.substring(1).split('')
          if (cor.length == 3) {
            cor = [cor[0], cor[0], cor[1], cor[1], cor[2], cor[2]]
          }
          cor = '0x' + cor.join('')
          color = 'rgba('+[(cor>>16)&255, (cor>>8)&255, cor&255].join(',')
        }

        // RETORNA O VALOR MONTADO
        return [ color + ',0.6)', color + ',1)' ]
      }
    }
  }
</script>
